module.exports = __webpack_public_path__ + "img/innovation.57ae970a.jpg";